/**
 * Translation keys whose "INFINIT" may be replaced with the organisation's brand.
 *
 * Intentionally empty: no copy is rebranded today.
 *
 * "INFINIT AI" keeps its name — it is the assistant's product name, not a label
 * for whichever organisation happens to be using it. Every remaining mention
 * names INFINIT as the counterparty: the entity holding the bank account,
 * providing the stock financing, issuing invoices, named in personal guarantees,
 * and owning the copyright. Renaming those misstates a financial or legal
 * relationship.
 *
 * Organisation branding is therefore artwork — wordmark, mark, favicon — plus the
 * login titles, which carry the brand through their own `{{brand}}` keys
 * (`splash.loginToBrand`, `signIn.welcomeTitleBranded`,
 * `signIn.loginTitleBranded`) and never pass through this allowlist.
 *
 * To rebrand a string, add its key here. Keyed rather than matched on the copy,
 * because the copy is translated into five languages and a content rule could
 * only ever be written in one; keys are identical across en/fr/es/it/de, so one
 * entry rebrands every locale consistently. Read the string in English first and
 * confirm it names the product, not the company.
 */
// Note: keys are resolved module namespaces, not directory names — the dashboard
// module registers its hook as "home", and the shared hook prefixes "shared.".
// Verify a new key against the hook that renders it.
export const BRANDABLE_TRANSLATION_KEYS: ReadonlySet<string> =
	new Set<string>();

/** True when this key's INFINIT mention refers to the product surface. */
export function isBrandableKey(key: string | undefined): boolean {
	return !!key && BRANDABLE_TRANSLATION_KEYS.has(key);
}
